import Navigation from "@/components/Navigation";
import Hero from "@/components/Hero";
import NewsFeed from "@/components/NewsFeed";
import About from "@/components/About";
import Services from "@/components/Services";
import Map from "@/components/Map";
import SocialLinks from "@/components/SocialLinks";
import Gallery from "@/components/Gallery";
import Testimonials from "@/components/Testimonials";

const Index = () => {
  return (
    <div className="min-h-screen">
      <Navigation />
      <Hero />
      <div className="relative">
        <NewsFeed />
      </div>
      <About />
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-5xl font-serif mb-12">Our Vision</h2>
          <div className="prose prose-xl mx-auto space-y-8 text-gray-600">
            <p className="italic text-2xl">
              At Evolutions MedSpa, we believe that beauty and self-expression are profound journeys of transformation, much like the artistic evolution of the great masters who redefined their craft over time. Each of our treatment rooms reflects the unique journey of an artist, embodying themes of growth, creativity, and self-discovery.
            </p>
            <p className="text-xl">
              Our vision is to guide our patients through their own personal evolution—aligning their aesthetic goals with their inner essence, as each step mirrors the artistic path of reinvention. From enhancing natural beauty to unveiling newfound confidence, we aim to create a space where our patients' journeys of self-care and empowerment are honored and celebrated.
            </p>
            <p className="font-medium text-xl">
              At Evolutions MedSpa, your transformation is our masterpiece. Together, we cultivate a harmony of artistry and science, ensuring that each patient leaves not only rejuvenated but also inspired to embrace their authentic self.
            </p>
          </div>
        </div>
      </section>
      <Services />
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6">
          <h2 className="text-4xl font-serif text-center mb-12">Client Transformations</h2>
          <Testimonials />
        </div>
      </section>
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <h2 className="text-4xl font-serif text-center mb-8">Our Gallery</h2>
          <Gallery className="mb-16" />
          <h2 className="text-4xl font-serif text-center mb-16">Visit Us</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
            <div className="space-y-6">
              <div className="space-y-4">
                <p className="text-lg">Evolutions Medspa</p>
                <p className="text-lg">9911 Kennerly Road, Suite C</p>
                <p className="text-lg">Saint Louis, MO 63128</p>
                <p className="text-lg">Phone: (314) 834-6004</p>
              </div>
              <div className="pt-6">
                <h3 className="text-xl font-serif mb-4">Connect With Us</h3>
                <SocialLinks />
              </div>
            </div>
            <Map />
          </div>
        </div>
      </section>
    </div>
  );
};

export default Index;